var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupportive = function SvgSupportive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#09671D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M7.22275 7.90054H6.57275C6.12402 7.90054 5.76025 8.26431 5.76025 8.71304V14.29C5.76025 14.7388 6.12402 15.1025 6.57275 15.1025H7.22275C7.67149 15.1025 8.03525 14.7388 8.03525 14.29V8.71304C8.03525 8.26431 7.67149 7.90054 7.22275 7.90054Z",
    stroke: "#09671D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.03516 9.15991V13.477C8.03516 13.908 8.20636 14.3213 8.51111 14.626C8.81585 14.9308 9.22918 15.102 9.66016 15.102H13.383C13.6801 15.102 13.9689 15.0043 14.205 14.824C14.4411 14.6438 14.6113 14.3908 14.6895 14.1042L15.7501 10.2107C15.8048 10.0099 15.8125 9.79911 15.7725 9.59481C15.7325 9.3905 15.646 9.19817 15.5196 9.03274C15.3932 8.86732 15.2304 8.73326 15.0438 8.64099C14.8572 8.54872 14.6518 8.50071 14.4436 8.5007H12.2255V6.43749C12.2255 6.15017 12.1114 5.87462 11.9082 5.67146C11.705 5.46829 11.4295 5.35416 11.1422 5.35416H11.1227C10.9433 5.35419 10.7668 5.39874 10.6089 5.48383C10.451 5.56892 10.3167 5.69187 10.2181 5.84166L8.03516 9.15991Z",
    stroke: "#09671D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSupportive;